import { render, staticRenderFns } from "./InvestmentAutoSuggest.vue?vue&type=template&id=0d94780f"
import script from "./InvestmentAutoSuggest.vue?vue&type=script&lang=js"
export * from "./InvestmentAutoSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports